import { render, staticRenderFns } from "./ArtistDivideLockList.vue?vue&type=template&id=0699c515&scoped=true"
import script from "./ArtistDivideLockList.vue?vue&type=script&lang=js"
export * from "./ArtistDivideLockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699c515",
  null
  
)

export default component.exports